export const escapeIdentifier = (name: string): string => {
  return `"${name.replace(/"/g, '""')}"`;
};
